export function isIdealPostcodesEnabled() {
  if (typeof window !== "undefined" && window.Cypress) {
    return false;
  }
  if (!process.env.VUE_APP_IDEAL_POSTCODES_API_KEY) {
    return false;
  }
  return process.env.VUE_APP_ENABLE_IDEAL_POSTCODES === "true";
}

export function isUnitedKingdomCountryCode(countryCode) {
  return countryCode === "GB";
}
